import { node, string } from "prop-types";
import { StyledLink } from "./styled";

const Link = ({
  to,
  children,
  /**
   * Even though `className` is not passed in for most instances of the `<Link />` component.
   * The property is required for styled-components to function.
   */
  className,
}) => (
  <StyledLink className={className} to={`${to}`}>
    {children}
  </StyledLink>
);

Link.propTypes = {
  to: string.isRequired,
  children: node.isRequired,
  className: string,
};

export default Link;
